backHref.$inject=['backUrlGenerator'];
function backHref(backUrlGenerator) {
    return function (url) {
        return backUrlGenerator.add_back_url(url);
    }
}

export default backHref